export const GFORM_SHORT_URL_REGEX = /^https:\/\/forms\.gle\/[\w-]+$/;

export const GFORM_URL_REGEX =
  /^https:\/\/docs\.google\.com\/forms\/d\/e\/[\w-]+\/viewform(\?.*)?$/;

export const GFORM_IFRAME_REGEX =
  /^<iframe.*src=["“]https:\/\/docs\.google\.com\/forms\/d\/e\/[\w-]+\/viewform\?embedded=true.*["”]>.*<\/iframe>/;
